/**
 * UserAvatar — a person's badge photo, by login.
 *
 * The same source as the portal sidebar's avatar (components/Sidebar): the corp badge-photo
 * service, falling back to the generic silhouette when the photo will not load (an unknown
 * login, or the service unreachable off the corp network). Round, and decorative — the login
 * is always written beside it.
 */

import './UserAvatar.css';

const BADGE_PHOTO_URL = 'https://badgephotos.corp.amazon.com/';
const FALLBACK = '/icons/user-avatar.svg';

export default function UserAvatar({ login, size = 16 }: { login: string; size?: number }) {
  return (
    <img
      className="eh-user-avatar"
      src={`${BADGE_PHOTO_URL}?uid=${encodeURIComponent(login)}`}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      onError={(e) => {
        const img = e.currentTarget;
        /* Once only: if the fallback itself fails, stop rather than loop. Guarded on the src,
           not by nulling `img.onerror` — React attaches its own listener, so that would leave
           this handler in place. `img.src` is absolute, hence endsWith. */
        if (img.src.endsWith(FALLBACK)) return;
        img.src = FALLBACK;
      }}
    />
  );
}
